import ReactDOM from "react-dom/client";
import "./styles/global.css";
import App from "./App";

import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";

ReactDOM.createRoot(document.getElementById("root")).render(

  <AuthProvider>

    <ToastProvider>

      <App />

    </ToastProvider>

  </AuthProvider>

);